export default angular.module("mars.vet.dnareports.controllers.health",[]).controller('HealthController',
        function($rootScope, $scope, $window, $uibModal,
                EntryService, EntryIDService, DisorderDataService, ImageService, NavigationService,
                TranslationService, UtilityService, WeightListService,
                reportdata) {
      'ngInject';
      var resultString = reportdata.resultString;
      var sampleDetails = reportdata.sampleDetails;

    var reportType = 'online';
    $scope.onloadFun = function() {
        reportType = 'pdf';
    }

    $scope.open = function () {
        var modalInstance = $uibModal.open({
            template: require('../partials/upgrademodal.html'),
            controller: 'UpgradeModalController'
        });
    }
    
    EntryService.getEntry(EntryIDService.getEntryID('Health')).then(function(response) {

        var fields = response.fields;
        if (reportType != 'pdf') {
            $rootScope.pageTitle = fields.title;
        }

        $scope.title = fields.title;
        $scope.description = fields.description.replace("[DOG NAME]", sampleDetails.petDetails.petName);
        $scope.seeDetails = TranslationService.getTranslation('See Details');
        $scope.getVersionFeature = UtilityService.getVersionFeature;
        var mdr1_enabled = UtilityService.getVersionFeature('MDR1');
        var traits_enabled = UtilityService.getVersionFeature('Traits');
        var eic_enabled = UtilityService.getVersionFeature('EIC');
 //       $scope.headerText = fields.upgradeText;
 //       $scope.upgradeNowUrl = fields.upgradeNowUrl.replace("<sampleID>", resultString.sampleID);
        $scope.allowUpgrade = sampleDetails.upgrade;
        // let modalOptions = {
        //     headerText: fields.upgradeText,
        //     closeButtonText: 'Upgrade Now'
        // };
        // $scope.modalOptions = modalOptions;

        if (mdr1_enabled) {
            var mdrOutcome;
            var copies;
            var mdrStatus;

            $scope.multiDrugSensitivity = TranslationService.getTranslation('Multidrug Sensitivity');
            $scope.multiDrugSensitivityEntryID = EntryIDService.getEntryID('Multidrug Sensitivity');
            $scope.translation = TranslationService.getTranslation;

            ImageService.getImageUrl("7L4BPe98OIYYoIO4MoyOMU").then(function(response) {
                $scope.mdr1ImageUrl = response.data.fields.file.url;
            });

            var disorderSnps = resultString.disorderSnps;
            angular.forEach(disorderSnps, function(result, key) {
                if (disorderSnps !== undefined && disorderSnps.length > 0 && result['snp_name'].indexOf("MDR1") != -1) {
                    mdrOutcome = result['outcome'];
                    copies = result['copies'];
                }
            });
            $scope.disorderSnps = resultString.disorderSnps[0];
            $scope.outcome = TranslationService.getTranslation('Normal/Normal');
            var multiDrugDescription = "";

            if (mdrOutcome == 'negative' && copies == 0) {
                mdrStatus = TranslationService.getTranslation('Normal/Normal', true);
                multiDrugDescription = fields.normalNormal;
            } else if (mdrOutcome == 'positive' && copies == 1) {
                mdrStatus = TranslationService.getTranslation('Mutant/Normal', true);
                multiDrugDescription = fields.mutantNormal;
            } else if (mdrOutcome == 'positive' && copies == 2) {
                mdrStatus = TranslationService.getTranslation('Mutant/Mutant', true);
                multiDrugDescription = fields.mutantMutant;
            } else if (mdrOutcome == 'fail' && copies == -1) {
                mdrStatus = TranslationService.getTranslation('Failed', true);
                multiDrugDescription = fields.failureDescription;
            }

            $scope.multiDrugDescription = multiDrugDescription.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName).replaceAll('[copy value]', copies);
            $scope.outcome = mdrStatus;
            $scope.copies = copies;
        }

        if (UtilityService.getVersionFeature('WisdomHealth')) {
            $scope.atRiskEntryID = EntryIDService.getEntryID('At Risk');
            $scope.carrierEntryID = EntryIDService.getEntryID('Carrier');
            $scope.allClearEntryID = EntryIDService.getEntryID('All Clear');
            $scope.noCallEntryID = EntryIDService.getEntryID('No Call');

            $scope.atRiskData = DisorderDataService.getAtRiskData();
            $scope.carrierData = DisorderDataService.getCarrierData();
            $scope.noCallData = DisorderDataService.getNoCallData();
            $scope.allClearData = DisorderDataService.getAllClearData();

            var totalDisorderCount = $scope.atRiskData.length + $scope.carrierData.length + $scope.noCallData.length + $scope.allClearData.length;
            var disorderCount = ($scope.atRiskData.length + $scope.carrierData.length + $scope.noCallData.length);
            var geneticHealthDescription;
            
            if(disorderCount > 0){
            	geneticHealthDescription = fields.geneticHealthDescription.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName).replaceAll('[DISORDERCOUNT]', totalDisorderCount);
            }
            else {
            	geneticHealthDescription = fields.clearDescription.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);
        	}
            
            $scope.geneticHealthDescription = geneticHealthDescription;
            
            ImageService.getImageUrl("1UJcKEfSy86QWQsKC2YwMC").then(function(response) {
                $scope.gHealthIcon = response.data.fields.file.url;
            });

            ImageService.getImageUrl("6ucbwArbUcuYsYYKmemcWM").then(function(response) {
                $scope.atRiskIcon = response.data.fields.file.url;
            });

            ImageService.getImageUrl("3m2L1bk9oQIGuK8Uw0SAk0").then(function(response) {
                $scope.carrierIcon = response.data.fields.file.url;
            });
            ImageService.getImageUrl("28BD224gKUUocC2WC2MuGE").then(function(response) {
                $scope.allClearIcon = response.data.fields.file.url;
            });

            ImageService.getImageUrl("3fc0BjHymsymwmYkII4mMo").then(function(response) {
                $scope.nocallIcon = response.data.fields.file.url;
            });
        }

        $scope.adultWeight = TranslationService.getTranslation('Adult Weight');
        $scope.videoDescription = fields.videoDescription;
        //        $scope.multiDrugSensitivity = TranslationService.getTranslation('Multidrug Sensitivity');

        if (UtilityService.getVersionFeature('Traits')) {
            $scope.traits = TranslationService.getTranslation('Traits');

            ImageService.getImageUrl("58xdnsFUhySIusyYyCaWUq").then(function(response) {
                $scope.traitsImageUrl = response.data.fields.file.url;
                $scope.traitsEntryID = EntryIDService.getEntryID('Traits');
            });
        }

        ImageService.getImageUrl("1o198Nn73O244sGss8IC2A").then(function(response) {
            $scope.adultWeightUrl = response.data.fields.file.url;
            $scope.adultWeightEntryID = EntryIDService.getEntryID('Adult Weight');
        });

        if (UtilityService.getVersionFeature('EIC') === true) {
            var eicOutcome;
            var eicCopies;
            var eicStatus;
            var eicDesc = "";

            angular.forEach(disorderSnps, function(result, key) {
                if (disorderSnps !== undefined && disorderSnps.length > 0 && result['snp_name'].indexOf("DNM1") != -1) {
                    eicOutcome = result['outcome'];
                    eicCopies = result['copies'];
                }

            });
            if (eicOutcome == 'negative' && eicCopies == 0) {
                eicStatus = TranslationService.getTranslation('Clear');
                eicDesc = fields.eicStatusDescription['Clear'];
            } else if (eicOutcome == 'positive' && eicCopies == 1) {
                eicStatus = TranslationService.getTranslation('Carrier');
                eicDesc = fields.eicStatusDescription['Carrier'];
            } else if (eicOutcome == 'positive' && eicCopies == 2) {
                eicStatus = TranslationService.getTranslation('Affected');
                eicDesc = fields.eicStatusDescription['Affected'];
            } else if (eicOutcome == 'fail' && eicCopies == -1) {
                eicStatus = TranslationService.getTranslation('Failed');
                eicDesc = fields.eicStatusDescription['Failed'];
            }
            $scope.eicDescription = eicDesc.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);
            $scope.eicStatus = eicStatus;

            ImageService.getImageUrl("tqsyNVWTYW8q08KMwsYMi").then(function(response) {
                $scope.eicImageUrl = response.data.fields.file.url;
            });
            //           $scope.multiDrugDescription=multiDrugDescription.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);
        }

        $scope.weightUnit = TranslationService.getTranslation('WeightMeasure');
        $scope.weightList = [];
        $scope.adultWeight = TranslationService.getTranslation('Adult Weight');
        $scope.weightList = WeightListService.getWeightList();
        $scope.adultWeightDescription = fields.adultWeightDescription.replaceAll("[DOG NAME]", sampleDetails.petDetails.petName);
        $scope.traitsDescription = fields.traitsDescription.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);
        NavigationService.setNavigationUrls();
        $window.ga('send', 'pageview', {
            'page': $rootScope.pageTitle
        });
    }, function(error) {
        // promise rejected, could log the error with:
        // console.log('error', error);
    });
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/health.controller.js